export const flexibleStartWeekDay = 99;
export const defaultStartWeekDay = 0;
export type WeekDay = 0 | 1 | 2 | 3 | 4 | 5 | 6;
export type StartWeekDay = WeekDay | 99;
